const STORAGE_KEY = "bd_cookie_consent";
const CONSENT_VERSION = 1;
const ADSENSE_CLIENT_ID = "ca-pub-5442070394016935";
const ADSENSE_SCRIPT_ID = "bd-adsense-script";

export const OPEN_PREFERENCES_EVENT = "bd:open-cookie-preferences";
export const CONSENT_UPDATED_EVENT = "bd:cookie-consent-updated";

export const DEFAULT_PREFERENCES = {
  necessary: true,
  analytics: false,
  advertising: false,
};

export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.version !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveConsent(preferences) {
  const record = {
    version: CONSENT_VERSION,
    preferences: { ...DEFAULT_PREFERENCES, ...preferences, necessary: true },
    decidedAt: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  window.dispatchEvent(new CustomEvent(CONSENT_UPDATED_EVENT, { detail: record.preferences }));

  if (record.preferences.advertising) {
    loadAdsenseScript();
  } else {
    removeAdsenseScript();
  }

  return record;
}

export function openCookiePreferences() {
  window.dispatchEvent(new Event(OPEN_PREFERENCES_EVENT));
}

export function loadAdsenseScript() {
  if (typeof document === "undefined") return;
  if (document.getElementById(ADSENSE_SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = ADSENSE_SCRIPT_ID;
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`;
  script.crossOrigin = "anonymous";
  document.head.appendChild(script);
}

export function removeAdsenseScript() {
  if (typeof document === "undefined") return;
  const script = document.getElementById(ADSENSE_SCRIPT_ID);
  if (script) script.remove();
}

export function initAdsenseFromStoredConsent() {
  const stored = getStoredConsent();
  if (stored?.preferences?.advertising) {
    loadAdsenseScript();
  }
}
